<template
  ><object-form-structure
    v-if="objectUuid"
    :title="getTitle()"
    :layer="objectLayer"
    :form="form"
    @close="$emit('close')"
    :object-uuid="objectUuid"
    :object-coordinate="searchObjectField(this.objectData, 'geo_json')"
    :labelIsLocked="objectData.tp_label_locked"
    @toggle-label-lock="changeLabelMode"

  >
    <v-expansion-panels v-model="panel" multiple id="form-fields" accordion>
      <v-expansion-panel
        :key="tab.code"
        v-for="tab in form.tabs"
        :disabled="panelIsDisable(tab)"
        v-if="panelIsVisible(tab)"
      >
        <v-expansion-panel-header>{{ tab.label }}</v-expansion-panel-header>

        <v-expansion-panel-content v-if="tab.type === 'photos'">
          <v-layout wrap justify-space-between class="ma-5">
            <network-photos
              v-for="image in previousImages"
              :key="image.id"
              :previous-image="image"
              :label="getImageLabel(image.name)"
            />
          </v-layout>
        </v-expansion-panel-content>

        <v-expansion-panel-content v-if="tab.type === 'form'">
          <v-layout wrap justify-space-between class="mx-5 my-2">
            <network-fields
              :key="field.id"
              v-for="field in tab.fields"
              :label="field.label_client ? field.label_client : field.label"
              :inputType="field.input_type"
              :value="getValueInObject(field.var_name)"
              :hide="field.hide"
              :size="field.size"
              :variable-name="field.var_name"
              :select-options="field.select_list_name"
              :material-options="materialOptions"
            />
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </object-form-structure>
</template>

<script>
import ObjectFormStructure from "@/components/Network/Forms/_Templates/ObjectFormStructure";
import NetworkFields from "@/components/Network/Forms/_Molecules/NetworkFields";
import { formsNetworkMixin } from "@/mixins/formsNetworkMixin";
import NetworkPhotos from "@/components/Network/Forms/_Molecules/NetworkPhotos";
export default {
  name: "ManholeForm",

  components: { NetworkPhotos, NetworkFields, ObjectFormStructure },

  mixins: [formsNetworkMixin],

  computed: {
    materialRequestQueryParameters() {
      return {
        material_family_id: "ch"
      };
    }
  },

  mounted() {
    this.loadMaterialOptions();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Network/Forms/ObjectForms/ChamberForm.vue